module.exports = {
      id: "close-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-9780240c1c89505db7f372dec3b5867e.svg#close",
      toString: function () {
        return this.url;
      }
    }